module.exports = __webpack_public_path__ + "img/sec5_4.76f25d32.jpg";